import React, { createContext } from "react";

const AccountContext = createContext<string>("");
export default AccountContext;
